import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretUp } from '@fortawesome/sharp-solid-svg-icons';

import { useNavigationContext } from '../provider';

export const MobileNavExpandButtons = () => {
  const { expandMobilePanel, setExpandMobilePanel } = useNavigationContext();
  return (
    <div className="space-x-5">
      <button
        className="disabled:text-gray-40"
        disabled={expandMobilePanel}
        type="button"
        onClick={() => {
          setExpandMobilePanel(true);
        }}
      >
        <FontAwesomeIcon className="!h-5 !w-5" icon={faCaretUp} />
      </button>
      <button
        className="disabled:text-gray-40"
        disabled={!expandMobilePanel}
        type="button"
        onClick={() => {
          setExpandMobilePanel(false);
        }}
      >
        <FontAwesomeIcon className="!h-5 !w-5" icon={faCaretDown} />
      </button>
    </div>
  );
};
